import { render, staticRenderFns } from "./AbsoluteEditor.vue?vue&type=template&id=5869460f&"
import script from "./AbsoluteEditor.vue?vue&type=script&lang=ts&"
export * from "./AbsoluteEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports